// angular.module("HeroPRO").controller("TopNavController", TopNavController);
// import moment from "moment";
import _ from 'lodash';

import './topNav.scss';
import './popovers/topNavPopover.scss';

/* @ngInject */
export default class TopNavController {
    constructor($window, $document, HPConfig, $state, $analytics, ModalService, UserAuthFactory, $scope, UiDisplayFactory, TopNavFactory, authenticationService, PartnerAppsFactory, SidebarFactory, moment, PermissionsFactory) {
        const vm = this;

        vm.isPopoverOpen = false;
        vm.isCollapsed = true;
        vm.navClass = '';
        vm.navItems = [];

        // (ajt 5/24/2016) Booleans to control element display on UI
        vm.showTopNav = false;
        vm.showCSLB = false;
        vm.showBenji = false;
        vm.benjiLink = PartnerAppsFactory.getBenjiLink();
        vm.showNavBar = showNavBar;
        vm.logout = logout;
        vm.openUserInfoDropDown = openUserInfoDropDown;
        vm.contactDropdownClick = contactDropdownClick;
        vm.kbygClick = kbygClick;
        vm.applicationClick = applicationClick;
        vm.coQRClick = coQRClick;
        vm.isPageActive = isPageActive;
        vm.showCoQR = false;
        vm.toolClick = toolClick;
        vm.proposalTools = ['Calculator', 'Proposal Plus'];
        vm.userInfoPopoverIsOpen = false;
        vm.contactInfoPopoverIsOpen = false;
        vm.proposalPopoverIsOpen = false;
        vm.proposalPlusEnabled = PermissionsFactory.hasPermission('ProposalPlus.Enabled');
        vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');
        vm.isAdvertiser = PermissionsFactory.hasPermission('IsAdvertiser');

        function showNavBar() {
            vm.isCollapsed = !vm.isCollapsed;
            if (vm.isCollapsed) {
                vm.navClass = '';
            } else {
                vm.navClass = 'topNav-collapse';
            }
        }

        function logout() {
            $analytics.eventTrack('Logout', {
                category: 'TopNav',
                label: $state.current.name,
            });

            TopNavFactory.logout().then(() => {
                // (ajt 3/23/16) PBI 414 Implement IDV validation
                authenticationService.logOut();

                UserAuthFactory.deleteAuthorization();

                let logoutUrl = HPConfig.heroProLoginLink;

                logoutUrl += '?logout=true';

                $window.location.href = logoutUrl;
            });
        }

        function proPitchClick() {
            $window.open(PartnerAppsFactory.getProPitchLink(), '_blank');
        }

        function heroCalculatorClick() {
            $analytics.eventTrack('Calculator Open', {
                category: 'TopNav',
                label: $state.current.name,
            });
            $window.open(PartnerAppsFactory.getHeroCalcLink(), '_blank');
        }

        function toolClick(toolName) {
            switch (toolName.toLowerCase()) {
            case 'proposal plus':
                proPitchClick();
                break;
            case 'calculator':
                heroCalculatorClick();
                break;
            default:
                break;
            }
        }

        function openUserInfoDropDown(open) {
            if (open) {
                $analytics.eventTrack('User details Shown', {
                    category: 'TopNav',
                    label: $state.current.name,
                });
            }
        }

        function contactDropdownClick(open) {
            if (open) {
                $analytics.eventTrack('Contact Dropdown Shown', {
                    category: 'TopNav',
                    label: $state.current.name,
                });
            }
        }

        function kbygClick() {
            $analytics.eventTrack('KBYG Open', {
                category: 'TopNav',
                label: $state.current.name,
            });
            ModalService.launchLgModal({
                templateUrl: 'app/lead/kbyg/modal/KBYGModalTemplate.html',
                windowClass: 'kbyg-modal',
                controller: 'KBYGModalController',
                controllerAs: 'kbygModal',
            });
        }

        function applicationClick() {
            $analytics.eventTrack('Application Open', {
                category: 'TopNav',
                label: $state.current.name,
            });
        }

        function coQRClick(username, organizationId) {
            const today = moment().local().format();

            $analytics.eventTrack('COQR Open', {
                category: 'TopNav',
                label: JSON.stringify({
                    username,
                    date: today,
                    organizationId,
                }),
            });
        }

        function isPageActive(viewLocation) {
            return viewLocation === $state.current.name;
        }

        function configureSidebarItem(item, rules) {
            _.each(rules, (rule, key) => {
                if (item.displayFlag === key) {
                    item.isEnabled = rule;
                }
            });
        }

        // prevent scroll when popovers are open on tablet and lower (SDM - Don't hate me for this.)
        $scope.$watch(() => vm.isPopoverOpen, (current) => {
            if ($window.outerWidth <= 992) {
                if (current === true) {
                    angular.element($document).find('body').css('overflow', 'hidden');
                } else {
                    angular.element($document).find('body').css('overflow', 'auto');
                }
            }
        });

        $scope.$on('UpdateDisplay', () => {
            // (ajt - 5/26/2016) TODO: Remove delay if the rules processing can be performed synchronously.
            _.defer(() => {
                const rules = UiDisplayFactory.getDisplayRules();
                vm.showBenji = rules.isBenjiUser;
                vm.isBenjiOnlyUser = rules.isBenjiOnlyUser;
                vm.showApply = rules.showApply;
                vm.showKbyg = rules.showKbyg;
                vm.showProposal = rules.showProposal && vm.proposalPlusEnabled === true;
                vm.showContact = rules.showContact;
                vm.showPersonalInfo = (rules.isBenjiOnlyUser) ? false : rules.showPersonalInfo;
                vm.showTopNavLocation = !rules.isBenjiOnlyUser;
                vm.backToProjects = rules.isBenjiOnlyUser;
                vm.showCSLB = rules.showCSLB;
                vm.showTopNav = true;
                vm.showCoQR = rules.showCoQR;


                // setup nav items (COPIED FROM SIDEBAR CONTROLLER - REFACTOR Opportunity? -> Propably in the factory itself...)
                vm.navItems = [];
                _.delay(() => {
                    const sidebarItems = _.map(SidebarFactory.getSidebar(), _.clone);
                    _.each(sidebarItems, (item) => {
                        configureSidebarItem(item, rules);
                        if (item.pageName.toLowerCase() === 'benji') {
                            item.isEnabled = rules.isBenjiUser;
                        }
                        if (item.isEnabled) {
                            vm.navItems.push(item);
                        }
                    });
                });
            });
        });

        // when changing window size manually reset popover to close
        angular.element($window).on('resize', () => {
            vm.isPopoverOpen = false;
        });
    }
}

TopNavController.$inject = ['$window', '$document', 'HPConfig', '$state', '$analytics', 'ModalService', 'UserAuthFactory', '$scope', 'UiDisplayFactory', 'TopNavFactory', 'authenticationService', 'PartnerAppsFactory', 'SidebarFactory', 'moment', 'PermissionsFactory'];




// WEBPACK FOOTER //
// ./src/app/common/topNav/TopNavController.js